import React, { useEffect, useState, useRef } from "react";
import {
  Paper,
  TextField,
  InputAdornment,
  Avatar,
  Badge,
  Typography,
  Button,
  Menu,
  MenuItem,
  Divider,
  IconButton,
  Box,
} from "@mui/material";
import classes from "./chat.module.css";
import moment from "moment";
import "../../../assets/css/chat.css";
import {
  AttachmentIcon,
  BrudCrumbNextIcon,
  CamIcon,
  CloseEyeIcon,
  EmojiIcon,
  MessageSentIcon,
  OpenEyeIcon,
  SearchIcon,
} from "../../../components/Icons";
import { BsThreeDotsVertical } from "react-icons/bs";
import EmojiPicker from "emoji-picker-react";
// import 'emoji-picker-react/dist/universal/style.scss';
import {
  authApi,
  authImageApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { GET_ONE_GROUP, UPLOAD_IMAGE } from "../../../api-calls/api-urls";
import { useDispatch, useSelector } from "react-redux";
import ChatContactCard from "./chatContactCard";
import {
  generateColor,
  stringAvatar,
  getTime,
  getUserGroupList,
  getConversationMessages,
  loadOlderConversationMessages,
  refreshLatestConversationMessages,
  checkOnline,
  getMqttData,
  addPersistentSubscription,
} from "../../../utilities/commonFunctions";
import MessageComponent from "./messageComponent";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AlertBox from "../../../components/AlertBox";
import CameraChatBox from "../../../components/ChatCamera";
import { base64ToBlob } from "../../../utilities/base64ToBlob";

// Mirrors the backend upload allowlist (config/storage.js) and its 10 MB cap.
const CHAT_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/plain",
  "text/csv",
];
const CHAT_FILE_EXTENSIONS = [
  "jpg", "jpeg", "png", "gif", "webp",
  "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv",
];
const MAX_CHAT_FILE_BYTES = 10 * 1024 * 1024;
const Chatindex = () => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const flatListRef = useRef(null);
  const [serachValue, setSearchValue] = React.useState("");
  const [company_id, setCompany_id] = useState("");
  const [serachValue1, setSearchValue1] = React.useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedUserProfile] = useState();
  const [selectedChat, setSelectedChat] = useState();
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const [openProfile, setOpenProfile] = useState(false);
  const [openSearch] = useState(false);
  const [messageOpenSearch, setmessageOpenSearch] = useState(false);
  const [selectedGroupData, setSelectedGroupData] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [searchOpen, setSearchOpen] = useState(false);
  const { grouplist, messagesList } = useSelector(
    (state) => state.chats
  );
  const { teamMembersList } = useSelector((state) => state.allUsers);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("File format not allowed.");
  const [memberFilter, setMemberFilter] = useState("");
  const [showCamera, setShowCamera] = useState(false);
  const [imageFile, setImageFile] = useState();

  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    dispatch(getUserGroupList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFileChange = async (event) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    // Same types the backend's upload filter (config/storage.js) accepts.
    // Checked by extension too: browsers report an empty type for some
    // Office files. SVG stays out — it can carry executable script.
    const ext = fileObj.name.split(".").pop()?.toLowerCase() || "";
    if (!CHAT_FILE_TYPES.includes(fileObj.type) && !CHAT_FILE_EXTENSIONS.includes(ext)) {
      setAlertMessage("File format not allowed.");
      setShowAlert(true);
      event.target.value = "";
      return;
    }
    if (fileObj.size > MAX_CHAT_FILE_BYTES) {
      setAlertMessage("File is too large. Please choose one under 10 MB.");
      setShowAlert(true);
      event.target.value = "";
      return;
    }
    await sendFile(fileObj);
    // Allow re-selecting the same file again (browsers don't fire `change`
    // for the same file path twice otherwise).
    event.target.value = "";
  };

  const openFileSelector = () => {
    inputRef.current.click();
  };

  // Track whether the user is scrolled to (or near) the bottom of the message list.
  // Only auto-scroll when they're already at the bottom — don't interrupt reading old messages.
  const isAtBottomRef = useRef(true);
  // Which page of history has been loaded for the currently open conversation,
  // and whether an older page is currently being fetched (guards duplicate
  // fetches from repeated scroll events).
  const loadedPageRef = useRef(1);
  const [isLoadingOlder, setIsLoadingOlder] = useState(false);

  const loadOlderMessages = async () => {
    if (isLoadingOlder || !selectedChat || !company_id) return;
    // The oldest loaded page's pagination says whether anything older
    // remains; hasMore comes from the cursor-aware backend, totalPages is
    // the fallback for one that predates it.
    const pagination = messagesList?.olderPagination || messagesList?.pagination;
    const hasMore =
      pagination?.hasMore ?? loadedPageRef.current < (pagination?.totalPages || 1);
    if (pagination && !hasMore) return;
    const before = messagesList?.messages?.[0]?._id;

    setIsLoadingOlder(true);
    const el = flatListRef.current;
    const prevScrollHeight = el ? el.scrollHeight : 0;
    const prevScrollTop = el ? el.scrollTop : 0;
    try {
      const nextPage = loadedPageRef.current + 1;
      const data = await dispatch(
        loadOlderConversationMessages(selectedChat, company_id, nextPage, before)
      );
      if (data) {
        loadedPageRef.current = nextPage;
        // Restore scroll position relative to the content the user was
        // looking at — otherwise prepending older messages yanks the view
        // down to whatever is now at scrollTop: 0.
        requestAnimationFrame(() => {
          if (flatListRef.current) {
            const newScrollHeight = flatListRef.current.scrollHeight;
            flatListRef.current.scrollTop =
              newScrollHeight - prevScrollHeight + prevScrollTop;
          }
        });
      }
    } finally {
      setIsLoadingOlder(false);
    }
  };

  const handleMessageScroll = () => {
    if (flatListRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = flatListRef.current;
      isAtBottomRef.current = scrollHeight - scrollTop - clientHeight < 80;
      if (scrollTop < 80) {
        loadOlderMessages();
      }
    }
  };

  useEffect(() => {
    if (flatListRef.current && isAtBottomRef.current) {
      flatListRef.current.scrollTop = flatListRef.current.scrollHeight;
    }
  }, [messagesList]);

  // Fetch messages when the user switches to a different chat. Deliberately
  // keyed on selectedChat only, not grouplist — grouplist is refreshed on
  // every inbound MQTT chat event (see mqttUtils.js), and depending on it
  // here used to mean every single chat event anywhere refetched the open
  // conversation's messages a second time, on top of the MQTT handler's own
  // targeted refetch for the conversation that actually changed.
  useEffect(() => {
    if (selectedChat) {
      const userInfo = sessionStorage.getItem("userInfo");
      if (userInfo) {
        const companyData = JSON.parse(userInfo); // Parse the string into an object
        if (companyData._id) {
          setCompany_id(companyData._id);
          loadedPageRef.current = 1;
          dispatch(getConversationMessages(selectedChat, companyData._id));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChat]);

  // const getGroupDetails = async () => {
  //   if (selectedChat && selectedChat.team_id) {
  //     const { data } = await authApi.get(`${GET_ONE_GROUP}/${selectedChat._id}`, {
  //       headers: { Authorization: getAuthorizationHeader() },
  //     });
  //     setSelectedGroupData(data);
  //   }
  // }

  // useEffect(() => {
  //   getGroupDetails(selectedChat);
  // }, [openProfile === true]);

  const handleSendMessage = async () => {
    if (!message.trim()) return;

    try {
      await authApi.post(
        "/messages/save-message",
        {
          conversation_id: selectedChat._id,
          message: message.trim(),
          file: null,
          file_name: null,
          receivers: selectedChat.receiver,
        },
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      setMessage("");
      // Refetch for the sender; receivers get triggered via MQTT from the backend
      dispatch(refreshLatestConversationMessages(selectedChat));
    } catch (error) {
      console.error("[handleSendMessage] Failed to send message:", error);
      setAlertMessage(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to send message. Please try again."
      );
      setShowAlert(true);
    }
  };

  // const getSelectedProfilePic = async (jid, dispatch) => {
  //   const id = jid?.split("@")[0];
  //   const userData = await authApi.get(`/users//user-details/${id}`, {
  //     headers: { Authorization: getAuthorizationHeader() },
  //   });
  //   setSelectedUserProfile(userData.data);
  // };

  // const setMessageLastMeesage = async (id, type) => {
  //   let userEntry = {
  //     conversation_type: type,
  //     conversation_id: id,
  //   };
  //   if (messagesList && messagesList?.length > 0) {
  //     userEntry.message_id = messagesList[messagesList?.length - 1].id;
  //     const { data } = await authApi.post(`/messages`, userEntry, {
  //       headers: { Authorization: getAuthorizationHeader() },
  //     });
  //     console.log(data);
  //   }
  // }

  const handleSetProfile = () => {
    setOpenProfile(!openProfile);
    handleClose();
    setVisibleCount(5);
  };

  const getGroupDetails = async (id) => {
    try {
      const { data } = await authApi.get(`${GET_ONE_GROUP}/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setSelectedGroupData(data);
    } catch (error) {
      console.error("[getGroupDetails] Failed to load group details:", error);
    }
  };

  useEffect(() => {
    if (openProfile && selectedChat) {
      getGroupDetails(selectedChat._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openProfile]);

  const OpenChat = async (member) => {
    setSelectedChat(member);
    dispatch(getConversationMessages(member, company_id));
    setMarkSeen(member);
    sessionStorage.setItem("selectedChat", JSON.stringify(member));
    // Subscribe persistently to this conversation's MQTT topic for real-time updates.
    // Using addPersistentSubscription ensures the topic survives MQTT reconnects.
    if (member.conversation_type === "group") {
      addPersistentSubscription(`App/Chat/Group/${member._id}`);
    }
  };

  const setMarkSeen = async (member) => {
    try {
      await authApi.put(
        `/messages/mark-seen/${member._id}`,
        {},
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      dispatch(getUserGroupList());
    } catch (error) {
      console.error("[setMarkSeen] Failed to mark conversation as seen:", error);
    }
  };

  const handleOpenSearch = () => {
    setmessageOpenSearch(!messageOpenSearch);
    handleClose();
    setSearchValue1("");
  };

  // const { isConnected, payload, publish } = useMqtt(
  //   awsConfig?.signedUrl,
  //   "presence"
  // );
  // console.log(isConnected, payload);

  // useEffect(() => {
  //   const fetchingSessionUrl = async () => {
  //     const response = await authApi.get("/map/get-aws-token", {
  //       headers: { Authorization: getAuthorizationHeader() },
  //     });
  //     setAwsConfig(response.data);
  //   };
  //   fetchingSessionUrl();
  // }, []);

  useEffect(() => {
    if (teamMembersList) {
      // Ensure the MQTT connection is up (needed for status subscriptions)
      getMqttData(`Message/${userInfo._id}`, teamMembersList, dispatch, "chat");
    }
    // Register as a persistent subscription so it survives every MQTT reconnect.
    // addPersistentSubscription is safe to call regardless of connection state —
    // it subscribes immediately if connected, and replays on every future reconnect.
    addPersistentSubscription(`App/Chat/Message/${userInfo._id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamMembersList]);

  // Subscribe to all group conversation topics as soon as the list loads.
  // This ensures the leader receives real-time MQTT updates for every group chat,
  // not just the one currently open. addPersistentSubscription survives reconnects.
  useEffect(() => {
    if (!grouplist?.length) return;
    grouplist.forEach((conversation) => {
      if (conversation.conversation_type === "group" && conversation._id) {
        addPersistentSubscription(`App/Chat/Group/${conversation._id}`);
      }
    });
  }, [grouplist]);

  const filteredList = grouplist.filter((item) =>
    (item.name || "").toLowerCase().includes(serachValue.toLowerCase())
  );

  const mediaList =
    messagesList?.messages && messagesList.messages.length > 0
      ? messagesList.messages.filter((msg) => !!msg.file_url)
      : [];

  const getTimestampedFilename = () => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
      now.getDate()
    )}`;
    const time = `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(
      now.getSeconds()
    )}`;
    return `camera_${date}_${time}.jpg`;
  };

  // camera image
  const handleSendImage = (img) => {
    try {
      const blob = base64ToBlob(img);
      const fileName = getTimestampedFilename();
      const file = new File([blob], fileName, { type: "image/jpeg" });
      setImageFile(file);
    } catch (error) {
      console.error("[handleSendImage] Failed to process captured image:", error);
    }
  };

  // Shared upload-then-send flow, used by both the camera capture and the
  // paperclip attachment button. (The paperclip previously called
  // handleSendMessage(fileObj) directly, which never uploaded anything —
  // it always posted message: null, file: null, silently dropping the file.)
  const sendFile = async (fileObj) => {
    if (!fileObj) return;
    try {
      const formData = new FormData();
      formData.append("file", fileObj);
      const { data } = await authImageApi.post(UPLOAD_IMAGE, formData, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      const fileUrl = data.data.location;
      const fileName = data.data.originalname;

      await authApi.post(
        "/messages/save-message",
        {
          conversation_id: selectedChat._id,
          message: null,
          file: fileUrl,
          file_name: fileName,
          receivers: selectedChat.receiver,
        },
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      dispatch(refreshLatestConversationMessages(selectedChat));
    } catch (error) {
      console.error("[sendFile] Failed to upload/send file:", error);
      setAlertMessage(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to send file. Please try again."
      );
      setShowAlert(true);
    }
  };

  const sendImage = async () => {
    await sendFile(imageFile);
    setShowCamera(false);
  };

  return (
    <div>
      <Paper
        className={classes.ChatContainerMainDiv}
        style={{
          gridTemplateColumns: openProfile ? `30% 43% 27%` : `33% 67%`,
          margin: "5px 0",
          // height: window.innerHeight - 120
          height: "calc(100vh - 120px)",
        }}
      >
        {/* user list */}
        <div className={classes.contactListcontainer}>
          <div>
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              placeholder="search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              fullWidth
              className={classes.teamMemberSearch}
              id="firstNameinput"
              value={serachValue}
              onChange={(e) => setSearchValue(e.target.value)}
              size="small"
            />
            <Box className={classes.ConatctList} sx={{ mt: 3 }}>
              {filteredList.map((member, index) => (
                <ChatContactCard
                  index={index}
                  OpenChat={OpenChat}
                  member={member}
                  ChatMembers={grouplist}
                  key={index}
                />
              ))}
            </Box>
          </div>
        </div>

        {/* message */}
        <div
          className={classes.Chat_messageMainCointainer}
          style={{ height: "calc(100vh - 120px)" }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <div className={classes.MessageBoxHEader}>
              <div
                className={classes.chat_IndividualContactsMainDiv}
                style={{ alignItems: "center" }}
              >
                {selectedChat ? (
                  <div className={classes.chat_IndividualContactsSubDiv}>
                    {selectedChat?.conversation_type === "individual" ? (
                      <Badge
                        color={
                          checkOnline(selectedChat?.receiverDetails[0]?._id) ===
                          "checkin"
                            ? "success"
                            : "error"
                        }
                        badgeContent=" "
                        variant="dot"
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                      >
                        {selectedChat?.receiverDetails[0]?.profile_pic ? (
                          <Avatar
                            alt="Remy Sharp"
                            src={`${process.env.REACT_APP_IMAGE_URL}/${selectedChat?.receiverDetails[0]?.profile_pic?.destination}${selectedChat?.receiverDetails[0]?.profile_pic?.filename}`}
                          />
                        ) : (
                          <Avatar
                            {...stringAvatar(`${selectedChat?.name.trim()}`)}
                            sx={{
                              bgcolor: selectedChat.departmentInfo?.colour
                                ? selectedChat.departmentInfo?.colour
                                : `${generateColor(
                                    `${selectedChat?.receiverDetails[0]?.name}`
                                  )}`,
                              textTransform: "uppercase",
                            }}
                          />
                        )}
                      </Badge>
                    ) : (
                      <Avatar
                        {...stringAvatar(`${selectedChat?.name.trim()}`)}
                        sx={{
                          backgroundImage:
                            "linear-gradient(to bottom, #1273B8, #BE5060)",
                          textTransform: "uppercase",
                        }}
                      />
                    )}
                    <Typography className={classes.chat_ContactPersonName}>
                      {/* {selectedChat?.name.split("-")[0]} */}
                      {selectedChat?.conversation_type === "group"
                        ? selectedChat?.name
                        : selectedChat?.receiverDetails[0]?.name || ""}
                    </Typography>
                  </div>
                ) : (
                  <div className={classes.chat_IndividualContactsSubDiv}></div>
                )}
                {selectedChat && (
                  <div className={`${classes.HeaderSearchBarContainer}`}>
                    {messageOpenSearch && (
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        placeholder="search"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                        className={classes.teamMemberSearch}
                        id="firstNameinput"
                        value={serachValue1}
                        onChange={(e) => setSearchValue1(e.target.value)}
                        size="small"
                      />
                    )}

                    <Button
                      variant="text"
                      className={classes.CardMenu}
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                      <BsThreeDotsVertical />
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      <MenuItem
                        sx={{ gap: "8px", alignItems: "center" }}
                        key={"viewIcon"}
                        onClick={() => handleSetProfile()}
                      >
                        {openProfile ? (
                          <>
                            <CloseEyeIcon />
                            <span>Close contact</span>
                          </>
                        ) : (
                          <>
                            <OpenEyeIcon />
                            <span>View contact</span>
                          </>
                        )}
                      </MenuItem>
                      <MenuItem
                        sx={{ gap: "8px", alignItems: "center" }}
                        key={"seachIcon"}
                        onClick={handleOpenSearch}
                      >
                        <SearchIcon />
                        <span>
                          {messageOpenSearch ? "Clear Search" : "Search"}{" "}
                        </span>
                      </MenuItem>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
            <div style={{ height: "calc(100vh - 390px)" }}>
              {selectedChat &&
              messagesList &&
              messagesList?.messages &&
              messagesList.messages.length > 0 ? (
                <Box
                  className={classes.MessageBoxBody}
                  ref={flatListRef}
                  onScroll={handleMessageScroll}
                  sx={{ mt: 2, mb: 0.5, overflowY: "auto", height: "calc(100vh - 390px)" }}
                >
                  {messagesList.messages
                    .filter((message) =>
                      (message.message || "")
                        .toLowerCase()
                        .includes(serachValue1.toLowerCase())
                    )
                    .map((message, index) => {
                      return (
                        <React.Fragment key={message._id}>
                          {index === 0 ? (
                            <div>
                              <Divider>
                                <Typography
                                  className={classes.Chat_lastMessage}
                                >
                                  {getTime(messagesList.messages[index]?.time)}
                                </Typography>
                              </Divider>
                            </div>
                          ) : (
                            moment(messagesList.messages[index]?.time).format(
                              "DD/MM/YYYY"
                            ) !==
                              moment(
                                messagesList.messages[index - 1]?.time
                              ).format("DD/MM/YYYY") && (
                              <div>
                                <Divider>
                                  <Typography
                                    className={classes.Chat_lastMessage}
                                  >
                                    {getTime(
                                      messagesList.messages[index]?.time
                                    )}
                                  </Typography>
                                </Divider>
                              </div>
                            )
                          )}
                          <MessageComponent
                            key={message._id}
                            userInfo={userInfo}
                            message={message}
                            index={index}
                            openProfile={openProfile}
                            selectedUserProfile={selectedUserProfile?.data}
                            selectedChat={selectedChat}
                          />
                        </React.Fragment>
                      );
                    })}
                </Box>
              ) : null}
            </div>
          </Box>

          <div className={`${classes.ChatInput}`}>
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                "& .MuiOutlinedInput-root": {
                  padding: "16px 150px 16px 16px",
                },
                "& .MuiInputBase-input": {
                  maxHeight: "100px",
                  scrollbarWidth: "none",
                },
              }}
              placeholder="message..."
              multiline
              fullWidth
              className={classes.MessageInput}
              id="firstNameinput"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => {
                // Enter sends; Shift+Enter inserts a newline, matching the
                // usual chat-app convention (and the mobile app's own input).
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleSendMessage();
                }
              }}
              inputProps={{ maxLength: 3000 }}
            />
            <input
              style={{ display: "none" }}
              ref={inputRef}
              type="file"
              onChange={handleFileChange}
              accept={[...CHAT_FILE_TYPES, ...CHAT_FILE_EXTENSIONS.map((e) => `.${e}`)].join(",")}
            />
            <div className={classes.chatSendBtnsContainer}>
              <span onClick={() => openFileSelector()}>
                <AttachmentIcon />
              </span>
              <span onClick={() => setShowPicker(!showPicker)}>
                {" "}
                <EmojiIcon />
              </span>
              <span onClick={() => setShowCamera(!showCamera)}>
                <CamIcon />
              </span>
              <span onClick={() => handleSendMessage()}>
                <MessageSentIcon />
              </span>
            </div>
          </div>
          {showCamera && (
            <>
              <CameraChatBox
                onCapture={handleSendImage}
                onClose={() => setShowCamera(false)}
                send={sendImage}
              />
            </>
          )}
          {showPicker && (
            <EmojiPicker
              pickerStyle={{ width: "100%" }}
              onEmojiClick={(emojiObject) =>
                setMessage((prevMsg) => prevMsg + emojiObject.emoji)
              }
              emojiStyle={"twitter"}
              categories={["smileys_people"]}
            />
            // <Picker pickerStyle={{ width: "100%" }} onEmojiClick={onEmojiClick} />
          )}
        </div>

        {/* user info */}
        {openProfile ? (
          <div
            className={classes.Chat_ContactDetailsMainCointainer}
            style={{
              display: "flex",
              flexDirection: "column",
              height: "calc(-120px + 100vh)",
            }}
          >
            {mediaOpen ? (
              <>
                <header style={{ display: "flex", gap: 4, padding: 8 }}>
                  <ChevronLeftRoundedIcon
                    sx={{ color: "#000" }}
                    onClick={() => setMediaOpen(false)}
                  />
                  <Typography className={classes.chat_ContactPersonName}>
                    {/* {selectedChat?.name.split("-")[0]} */}
                    selectedChat
                  </Typography>
                </header>
                <hr />
                <section style={{ padding: 4 }}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(100px, 1fr))",
                      gap: 4,
                    }}
                  >
                    {mediaList.map((message) => {
                      return message?.file_name?.includes("mp3") ? (
                        <div
                          style={{
                            border: "1px solid #e7e7e7",
                            display: "flex",
                            placeItems: "center",
                          }}
                        >
                          <audio controls style={{ width: "100%" }}>
                            <source
                              src={message?.file_url}
                              type="audio/ogg"
                            ></source>
                            <source
                              src={message?.file_url}
                              type="audio/mpeg"
                            ></source>
                          </audio>
                        </div>
                      ) : (
                        <div
                          style={{
                            border: "1px solid #e7e7e7",
                            display: "flex",
                            placeItems: "center",
                          }}
                        >
                          <img
                            src={message?.file_url}
                            alt=""
                            style={{ height: "100px", width: "100%" }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </section>
              </>
            ) : (
              <>
                <div style={{ padding: "15px" }}>
                  <div className={classes.chat_IndividualContactsSubDiv}>
                    {selectedChat.conversation_type === "group" ? (
                      <Avatar
                        {...stringAvatar(`${selectedChat?.name.trim()}`)}
                        sx={{
                          backgroundImage:
                            "linear-gradient(to bottom, #1273B8, #BE5060)",
                          textTransform: "uppercase",
                        }}
                      />
                    ) : (
                      <Badge
                        color={
                          checkOnline(selectedChat?.receiverDetails[0]?._id) ===
                          "checkin"
                            ? "success"
                            : "error"
                        }
                        badgeContent=" "
                        variant="dot"
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                      >
                        {selectedChat && selectedChat.group_name ? (
                          <Avatar
                            {...stringAvatar(selectedChat.group_name)}
                            sx={{
                              bgcolor: `${generateColor(
                                selectedChat.group_name
                              )}`,
                              width: 60,
                              height: 60,
                              fontSize: 16,
                              fontWeight: 600,
                              textTransform: "uppercase",
                            }}
                          ></Avatar>
                        ) : selectedUserProfile &&
                          selectedUserProfile?.profile &&
                          selectedUserProfile?.profile_pic?.filename ? (
                          <Avatar
                            alt="Remy Sharp"
                            src={`${process.env.REACT_APP_IMAGE_URL}/${selectedUserProfile?.profile_pic?.destination}${selectedUserProfile?.profile_pic?.filename}`}
                          />
                        ) : (
                          <Avatar
                            {...stringAvatar(`${selectedChat?.name.trim()}`)}
                            sx={{
                              bgcolor: selectedChat.departmentInfo?.colour
                                ? selectedChat.departmentInfo?.colour
                                : `${generateColor(
                                    `${selectedChat?.receiverDetails[0]?.name}`
                                  )}`,
                              textTransform: "uppercase",
                            }}
                          />
                        )}
                      </Badge>
                    )}
                    <div>
                      <Typography className={classes.chat_ContactPersonName}>
                        {/* {selectedChat?.name.split("-")[0]} */}
                        {selectedChat?.conversation_type === "group"
                          ? selectedChat?.name
                          : selectedChat?.receiverDetails[0]?.name || ""}
                      </Typography>
                      <Typography
                        className={classes.Chat_lastMessage}
                      ></Typography>
                    </div>
                  </div>
                  <hr className={classes.Chart_contactUnderLine} />
                  <div className={classes.ContactSubDiv}>
                    <div>
                      <Typography className={classes.Chat_lastMessage}>
                        Since Joining
                      </Typography>
                      <Typography className={classes.chatOtherImportantTexts}>
                        {moment(selectedChat?.createdAt).format("DD/MM/YYYY")}
                      </Typography>
                    </div>
                    <div>
                      <Typography className={classes.Chat_lastMessage}>
                        {selectedChat.team_id ? "Group ID" : "Employee ID"}
                      </Typography>
                      <Typography className={classes.chatOtherImportantTexts}>
                        {selectedChat?._id.slice(0, 6)}
                      </Typography>
                    </div>
                  </div>
                </div>
                <Box
                  className={classes.MedeasLinkContainerBox}
                  sx={{ mt: 1 }}
                  onClick={() => setMediaOpen(true)}
                >
                  <Typography className={classes.chatOtherImportantTexts}>
                    Media, Link, and Docs
                  </Typography>
                  <Typography className={classes.Chat_lastMessage}>
                    {mediaList.length} <BrudCrumbNextIcon />
                  </Typography>
                </Box>
                <div
                  style={{
                    padding: "15px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto",
                  }}
                >
                  {/* group members list */}
                  {selectedChat.conversation_type === "group" && (
                    <>
                      <span
                        style={{
                          display: "flex",
                          placeContent: "space-between",
                          placeItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <Typography
                          className={`${classes.chat_ContactPersonName}`}
                        >
                          Members
                        </Typography>
                        <IconButton onClick={() => setSearchOpen(!searchOpen)}>
                          {searchOpen ? (
                            <CloseRoundedIcon
                              sx={{ color: "#6b778c", fontSize: "1rem" }}
                            />
                          ) : (
                            <SearchIcon />
                          )}
                        </IconButton>
                      </span>
                      {searchOpen && (
                        <TextField
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            mb: "8px",
                          }}
                          placeholder="search"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            ),
                          }}
                          fullWidth
                          className={classes.teamMemberSearch}
                          id="firstNameinput"
                          value={memberFilter}
                          onChange={(e) => setMemberFilter(e.target.value)}
                          size="small"
                        />
                      )}
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          flexDirection: "column",
                          overflow: "auto",
                        }}
                      >
                        {!memberFilter && (
                          <div
                            style={{
                              display: "flex",
                              placeItems: "center",
                              placeContent: "space-between",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                gap: "8px",
                                placeContent: "flex-start",
                                placeItems: "center",
                              }}
                            >
                              <Avatar
                                {...stringAvatar(`${userInfo?.name?.trim()}`)}
                                sx={{
                                  backgroundImage:
                                    "linear-gradient(to bottom, #1273B8, #BE5060)",
                                  width: 32,
                                  height: 32,
                                  fontSize: 14,
                                  fontWeight: 600,
                                  textTransform: "uppercase",
                                }}
                              />
                              {userInfo?.name}
                            </span>
                            <span
                              style={{
                                fontSize: "0.7rem",
                                color: "#6B778C",
                                marginRight: "16px",
                              }}
                            >
                              Admin
                            </span>
                          </div>
                        )}
                        {messagesList?.teamDetails.length > 0 &&
                          messagesList?.teamDetails
                            ?.find((team) => team._id === selectedChat.team_id)
                            ?.team_members.filter((member) =>
                              member.user_name
                                .toLowerCase()
                                .includes(memberFilter.toLowerCase())
                            )
                            .slice(0, visibleCount)
                            .map((member) => {
                              return (
                                <div
                                  key={member._id}
                                  style={{
                                    display: "flex",
                                    gap: "8px",
                                    placeContent: "flex-start",
                                    placeItems: "center",
                                  }}
                                >
                                  <>
                                    <Avatar
                                      {...stringAvatar(
                                        `${member?.user_name.trim()}`
                                      )}
                                      sx={{
                                        bgcolor: member?.departmentInfo?.colour
                                          ? member.departmentInfo.colour
                                          : `${generateColor(
                                              `${member?.receiverDetails[0]?.name}`
                                            )}`,
                                        width: 32,
                                        height: 32,
                                        fontSize: 14,
                                        fontWeight: 600,
                                        textTransform: "uppercase",
                                      }}
                                    />{" "}
                                    {member.user_name}
                                  </>
                                </div>
                              );
                            })}
                        {messagesList?.teamDetails.length > 0 &&
                          visibleCount <
                            messagesList?.teamDetails
                              ?.find(
                                (team) => team._id === selectedChat.team_id
                              )
                              ?.team_members.filter((member) =>
                                member.user_name
                                  .toLowerCase()
                                  .includes(memberFilter.toLowerCase())
                              ).length && (
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setVisibleCount(
                                  messagesList?.teamDetails.find(
                                    (team) => team._id === selectedChat.team_id
                                  )?.team_members.length
                                )
                              }
                            >
                              View All (
                              {messagesList?.teamDetails.find(
                                (team) => team._id === selectedChat.team_id
                              )?.team_members.length - visibleCount}{" "}
                              More)
                            </span>
                          )}
                      </div>
                    </>
                  )}
                  <div>
                    {selectedChat.team_id && selectedGroupData ? (
                      <div>
                        {selectedGroupData.admins.map((item, index) => (
                          <div
                            key={index}
                            className={classes.chat_IndividualContactsMainDiv}
                          >
                            <div className={classes.NameBars}>
                              {item &&
                              item?.profile &&
                              item?.profile_pic?.filename ? (
                                <Avatar
                                  alt="Remy Sharp"
                                  src={`${process.env.REACT_APP_IMAGE_URL}/${item?.profile_pic?.destination}${item?.profile_pic?.filename}`}
                                />
                              ) : (
                                <Avatar
                                  {...stringAvatar(`${item?.name?.trim()}`)}
                                  sx={{
                                    bgcolor: `${generateColor(
                                      `${item?.name?.trim()}}`
                                    )}`,
                                    width: 32,
                                    height: 32,
                                    fontSize: 14,
                                    fontWeight: 600,
                                    textTransform: "uppercase",
                                  }}
                                />
                              )}
                              <Typography
                                className={classes.chatOtherImportantTexts}
                              >
                                {item?.name}
                              </Typography>
                            </div>
                            <Typography className={classes.Chat_lastMessage}>
                              {"Admin"}
                            </Typography>
                          </div>
                        ))}
                        {selectedGroupData.group_members.map((item, index) => (
                          <div key={index}>
                            <div className={classes.NameBars}>
                              {item &&
                              item?.profile &&
                              item?.profile_pic?.filename ? (
                                <Avatar
                                  alt="Remy Sharp"
                                  src={`${process.env.REACT_APP_IMAGE_URL}/${item?.profile_pic?.destination}${item?.profile_pic?.filename}`}
                                />
                              ) : (
                                <Avatar
                                  {...stringAvatar(`${item?.name?.trim()}`)}
                                  sx={{
                                    bgcolor: `${generateColor(
                                      `${item?.name?.trim()}}`
                                    )}`,
                                    width: 32,
                                    height: 32,
                                    fontSize: 14,
                                    fontWeight: 600,
                                    textTransform: "uppercase",
                                  }}
                                />
                              )}
                              <Typography
                                className={classes.chatOtherImportantTexts}
                              >
                                {item?.name}
                              </Typography>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>
                </div>
              </>
            )}
          </div>
        ) : openSearch ? (
          <div className={classes.Chat_ContactDetailsMainCointainer}></div>
        ) : null}
      </Paper>

      {showAlert && (
        <AlertBox
          type="error"
          message={alertMessage}
          stateName={setShowAlert}
        />
      )}
    </div>
  );
};

export default Chatindex;
